import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FieldConfig } from '../../_models/field.interface';
import { AuthService } from '../../_services/auth.service';
import { UploadFilesService } from '../../_services/upload-files.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FidelidadeService } from '../../_services/fidelidade.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.scss'],
})
export class PerfilComponent implements OnInit {
  regConfigImagemPessoa: FieldConfig[] = [];
  regConfigDadosPessoa: FieldConfig[] = [];
  regConfigBonusNivel: FieldConfig[] = [];
  regConfigDesafios: FieldConfig[] = [];

  regConfigCarouselVertical: FieldConfig[] = [];

  idNivel: number = 0;
  userName: string = '';

  regMenuPerfilCarousel: FieldConfig[] = [];
  fields: FieldConfig[] = [];

  itensMenuCarousel = [];
  exibePopupUpload: boolean = false;
  exibePopupSac: boolean = false;
  exibirPopupGuide: boolean = false;

  carregandoPerfil: boolean = false;

  constructor(
    private authService: AuthService,
    private uploadFilesService: UploadFilesService,
    private sanitizer: DomSanitizer,
    private fidelidade: FidelidadeService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.carregarDadosMembro();
    this.carregarDesafios();

    this.authService.LocalStorage.currentUserToken.subscribe((user) => {
      this.userName = user ? user.nome.split(' ')[0] : null;
    });
  }

  carregarDadosMembro() {
    this.carregandoPerfil = true;
    this.fidelidade.obterMembro().subscribe(
      (sucesso) => this.processarSucessoMembro(sucesso),
      (falha) =>
        console.error(
          'Ocorreu um erro ao tentar carregar os dados do membro',
          falha
        )
    );
  }

  processarSucessoMembro(sucesso: any) {
    this.authService.LocalStorage.currentUserToken.subscribe(
      (user) => {
        if (user) {
          var username = user.nome.split(' ');
          var nomeSobrenome = username[0] + ' ' + username[1];
        }
        var config: object = {
          porcentagemNivel: sucesso.nivelRange.porcentagemNivel,
          idNivel: sucesso.idNivel,
          descricaoNivel: sucesso.descricaoNivel
            ? sucesso.descricaoNivel
            : 'Não identificado',
          xpDoNivel:
            (sucesso.nivelRange.proximoXP
              ? sucesso.nivelRange.proximoXP
              : sucesso.nivelRange.xpAnterior) - sucesso.nivelRange.xpAnterior,

          saldoXP: sucesso.saldo.saldoXP,
          pontosProximoNivel: sucesso.nivelRange.proximoXP
            ? sucesso.nivelRange.proximoXP
            : sucesso.nivelRange.xpAnterior,
          pontosRestantes: sucesso.nivelRange.pontosRestantesProximoNivel,

          xpAtualDoNivel: sucesso.saldo.saldoXP - sucesso.nivelRange.xpAnterior,
          descricaoProximoNivel: sucesso.nivelRange.proximoXPDescricao,
          nome: nomeSobrenome,
        };
        this.idNivel = sucesso.idNivel;

        this.processarElementos(config);

        if (
          sucesso.caminhoFoto != '' &&
          sucesso.caminhoFoto != null &&
          sucesso.caminhoFoto != undefined
        )
          this.regConfigDadosPessoa[0].circleProgress.imageSrc =
            sucesso.caminhoFoto;
        else
          this.regConfigDadosPessoa[0].circleProgress.imageSrc =
            'assets/images/chocomonstros/monstro1.png';
      },
      () => this.processarFalhaMembro('Erro na configuração do usuário!')
    );
  }
  processarFalhaMembro(falha: any) {
    console.error(
      'Ocorreu um erro ao tentar carregar o perfil do membro',
      falha
    );
    alert('Ocorreu um erro inesperado ao carregar o perfil!');
  }

  transform(): Observable<any> {
    return this.uploadFilesService.getPhotoProfile().pipe(
      map((res) => {
        if (res.base64 == undefined)
          return this.sanitizer.bypassSecurityTrustResourceUrl(
            'assets/images/others/perfil_default.png'
          );
        else
          return this.sanitizer.bypassSecurityTrustResourceUrl(
            'data:image/jpeg;base64,' + res.base64
          );
      })
    );
  }

  processarElementos(config: any) {
    var self = this;
    this.carregarItensMenu();

    var colorNivel = '#F4B241';
    // if (config.idNivel == 1) colorNivel = '#20c261';
    // if (config.idNivel == 2) colorNivel = '#1ac2b0';
    // if (config.idNivel == 3) colorNivel = '#00a4d5';

    var nome = config.nome.toUpperCase().split(' ');

    this.regConfigDadosPessoa = [
      {
        type: 'circleProgress',
        circleProgress: {
          //'imageSrc': this.transform().subscribe((res) => { this.regConfigDadosPessoa[0].circleProgress.imageSrc = res.changingThisBreaksApplicationSecurity; }),
          sizeStroke: 12,
          color: 'var(--circle-progress-nivel-background-color)',
          value: 0,
          backgroundColor: '#E8DFCA',
          exibeTrufa: false,
          onClick: () => {
            self.router.navigate(['/meusdados']);
          },
        },
        styleDivPrincipal(): object {
          return {
            width: '102px',
            display: 'block',
            margin: 'auto',
          };
        },
      },
      {
        type: 'label',
        label: `${nome[0]}\n${nome[1]}`,
        style(): object {
          return {
            display: 'block',
            margin: 'auto',
            'text-align': 'center',
            'font-size': '20px',
            'font-weight': '700',
            'line-height': '23px',
            color: '#461F1A',
            'margin-bottom': '15px',
          };
        },
        onClick(): void {},
      },
      // {
      //   type: 'label',
      //   label: config.descricaoNivel,
      //   style(): object {
      //     return {
      //       display: 'block',
      //       margin: 'auto',
      //       'font-size': '16px',
      //       'text-align': 'center',
      //     };
      //   },
      //   onClick(): void {},
      // },
    ];

    var xpLabel: string =
      config.pontosRestantes != 0
        ? 'Alcance o nível ' +
          config.descricaoProximoNivel +
          '\nacumulando mais ' +
          config.pontosRestantes +
          ' nibs.'
        : 'Meus parabéns!!!\nVocê atingiu o nível máximo.';

    // this.itensMenuCarousel = [
    //     {
    //         imgBackground: 'assets/images/others/menu_item_background.png',
    //         imgIcon: 'assets/images/icons/extratos.png',
    //         styleImgIcon(): object { return carouselStyle },
    //         styleLabel(): object { return labelCarouselStyle },
    //         label: 'Extrato\nde compras',
    //         link: '/extrato'
    //     },
    //     {
    //         imgBackground: 'assets/images/others/menu_item_background.png',
    //         imgIcon: 'assets/images/icons/pedidos.png',
    //         styleImgIcon(): object { return carouselStyle },
    //         styleLabel(): object { return labelCarouselStyle },
    //         label: 'Meus\npedidos',
    //         link: '/meuspedidos'
    //     },
    //     {
    //         imgBackground: 'assets/images/others/menu_item_background.png',
    //         imgIcon: 'assets/images/icons/atendimento.png',
    //         styleImgIcon(): object { return carouselStyle },
    //         styleLabel(): object { return labelCarouselStyle },
    //         link: '/atendimento'
    //     },
    //     {
    //         imgBackground: 'assets/images/others/menu_item_background.png',
    //         imgIcon: 'assets/images/icons/meus_dados.png',
    //         styleImgIcon(): object { return carouselStyle },
    //         styleLabel(): object { return labelCarouselStyle },
    //         label: 'Meus\ndados',
    //         link: '/meusdados'
    //     },
    // ];

    this.regConfigBonusNivel = [
      // {
      //     type: 'circleProgress',
      //     circleProgress: {
      //         'color': colorNivel,
      //         'value': 50,
      //         'maxValue': 200,
      //         'exibeLegenda': true,
      //         'radius': 40,
      //         'backgroundColor': '#ffffff',
      //     },
      //     styleDivPrincipal(): object {
      //         return {
      //             'width': '102px',
      //             'position': 'absolute',
      //             'margin-top': '30px',
      //             'left': '2.5rem'
      //         }
      //     }
      // },
      // {
      //     type: 'label',
      //     label: 'Acumule mais 50 pontos\n para comprar 5 tabletes\n laCreme.',
      //     style(): object {
      //         return {
      //             'width': '170px',
      //             'margin-top': '50px',
      //             'font-size': '14px',
      //             'position': 'absolute',
      //             'left': '9.5rem'
      //         }
      //     }
      // },
      {
        type: 'circleProgress',
        circleProgress: {
          color: 'var(--circle-progress-nivel-background-color)',
          value: config.saldoXP,
          maxValue: config.pontosProximoNivel,
          porcent: config.porcentagemNivel,
          radius: 40,
          exibeLegenda: true,
          backgroundColor: '#ffffff',
        },
        styleDivPrincipal(): object {
          return {
            width: '102px',
            position: 'absolute',
            right: '3rem',
            'margin-top': '30px',
          };
        },
      },
      {
        type: 'label',
        label: xpLabel,
        style(): object {
          return {
            width: '170px',
            'margin-top': '50px',
            'font-size': '14px',
            position: 'absolute',
            right: '10.5rem',
            'text-align': 'right',
          };
        },
      },
    ];

    this.carregandoPerfil = false;
  }

  carregarItensMenu() {
    var carouselStyle: object = {
      position: 'absolute',
      top: '20%',
      left: '50%',
      transform: 'translateX(-50%)',
      height: '50px',
      width: '50px',
    };
    var labelCarouselStyle = {
      position: 'absolute',
      top: '58%',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '70%',
      height: '28px',
      'font-size': '14px',
      'font-weight': '700',
      'line-height': '16px',
      color: '#461F1A',
      'text-align': 'center',
      'text-decoration': 'none',
    };

    this.itensMenuCarousel = [
      //{
      //imgBackground: 'assets/images/others/menu_item_background.png',
      //imgIcon: 'assets/images/icons/extratos.png',
      //styleImgIcon(): object {
      //return carouselStyle;
      //},
      //styleLabel(): object {
      //return labelCarouselStyle;
      //},
      //label: 'Extrato\nde Cacaus (pontos)',
      //link: '/extrato',
      //},
      {
        imgBackground: 'assets/images/others/menu_item_background.png',
        imgIcon: 'assets/images/icons/pedidos.png',
        styleImgIcon(): object {
          return carouselStyle;
        },
        styleLabel(): object {
          return labelCarouselStyle;
        },
        label: 'Meus\npedidos',
        link: '/meuspedidos',
      },
      // {
      //   imgBackground: 'assets/images/others/menu_item_background.png',
      //   imgIcon: 'assets/images/icons/notificacao.png',
      //   styleImgIcon(): object {
      //     return carouselStyle;
      //   },
      //   styleLabel(): object {
      //     return labelCarouselStyle;
      //   },
      //   label: 'Notificação',
      //   link: '/notificacoes',
      // },
      {
        imgBackground: 'assets/images/others/menu_item_background.png',
        imgIcon: 'assets/images/icons/atendimento.png',
        styleImgIcon(): object {
          return carouselStyle;
        },
        styleLabel(): object {
          return labelCarouselStyle;
        },
        label: 'Atendimento',
        link: '/atendimento',
      },
      {
        imgBackground: 'assets/images/others/menu_item_background.png',
        imgIcon: 'assets/images/icons/meus_dados.png',
        styleImgIcon(): object {
          return carouselStyle;
        },
        styleLabel(): object {
          return labelCarouselStyle;
        },
        label: 'Meus\ndados',
        link: '/meusdados',
      },
    ];

    this.regConfigCarouselVertical = [];
    this.fields = [];
    for (let index = 0; index < this.itensMenuCarousel.length; index += 2) {
      this.fields.push({
        type: 'carousel',
        showArrows: false,
        maxSize: 140,
        height: 140,
        styleDivPrincipal(): object {
          return {
            'text-align': '-webkit-center',
          };
        },
        itensCarousel: this.itensMenuCarousel.slice(index, index + 2),
      });
    }
    for (let index = this.fields.length - 1; index >= 0; index--) {
      this.regConfigCarouselVertical.unshift(this.fields[index]);
    }
  }

  exibirPopupUpload() {
    this.exibePopupUpload = true;
  }
  fecharPopup() {
    this.exibePopupUpload = false;
    window.location.reload();
  }

  exibirPopupSac() {
    this.exibePopupSac = true;
  }

  abrirPopupGuide(): void {
    this.exibirPopupGuide = true;
  }

  fecharPopupGuide(): void {
    this.exibirPopupGuide = false;
  }

  // controleMenuPerfil(item: any): void {
  //     if (item.onClick) item.onClick();

  //     if (item.link) this.router.navigate([item.link]);
  // }

  controleMenuPerfil(link: string, novaAba: boolean = false) {
    if (novaAba)
      this.router.navigate([]).then((result) => {
        window.open(link, '_blank');
      });
    else this.router.navigate([link]);
  }

  carregarDesafios() {
    this.regConfigDesafios = [
      {
        type: 'label',
        label: 'Desafios',
        styleDivPrincipal: () => {
          return {
            width: '100%',
          };
        },
        style: () => {
          return {
            width: '100%',
            'font-size': '1.1em',
            'font-weight': '700',
            color: '#A08763',
            'text-align': 'center',
          };
        },
      },
      {
        type: 'desafiosCarousel',
        desafio: {
          exibirDesafioCompleto: true,
          exibirDesafioIncompleto: true,
          exibirSaibaMais: true,
        },
      },
    ];
  }
}
